import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';
import {
  Add as AddIcon,
  ArrowUpward as ArrowUpIcon,
  ArrowDownward as ArrowDownIcon,
  Delete as DeleteIcon,
  DragIndicator as DragIcon,
} from '@mui/icons-material';

const Multiselect = ({
  useKey,
  allItems,
  selectedItems,
  setSelectedItems,
  title,
  emptyMessage,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  // ✅ Уникальный ключ для объекта {type, value}
  const getItemKey = (item) => `${item.type}-${item.value}`;

  const handleAddClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAddItem = (item) => {
    const newSelected = [...selectedItems, item];
    setSelectedItems(newSelected);
    setAnchorEl(null);
  };

  // ✅ Фильтрация доступных объектов
  const availableItems = allItems.filter(
    (availableItem) =>
      !selectedItems.some(
        (selectedItem) =>
          selectedItem.type === availableItem.type &&
          selectedItem.value === availableItem.value
      )
  );

  const handleItemClick = (index) => {
    setSelectedIndex(index);
  };

  const handleMoveUp = () => {
    if (selectedIndex > 0) {
      const newSelected = [...selectedItems];
      [newSelected[selectedIndex - 1], newSelected[selectedIndex]] = [
        newSelected[selectedIndex],
        newSelected[selectedIndex - 1],
      ];
      setSelectedItems(newSelected);
      setSelectedIndex(selectedIndex - 1);
    }
  };

  const handleMoveDown = () => {
    if (selectedIndex < selectedItems.length - 1 && selectedIndex >= 0) {
      const newSelected = [...selectedItems];
      [newSelected[selectedIndex], newSelected[selectedIndex + 1]] = [
        newSelected[selectedIndex + 1],
        newSelected[selectedIndex],
      ];
      setSelectedItems(newSelected);
      setSelectedIndex(selectedIndex + 1);
    }
  };

  const handleRemoveItem = () => {
    if (selectedIndex >= 0) {
      const newSelected = selectedItems.filter(
        (_, index) => index !== selectedIndex
      );
      setSelectedItems(newSelected);
      setSelectedIndex(-1);
    }
  };

  const handleRemoveAll = () => {
    setSelectedItems([]);
    setSelectedIndex(-1);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const isSelected = (index) => index === selectedIndex;

  return (
    <Box
      sx={{
        width: '100%',
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        p: 2,
        mt: 2,
      }}
    >
      {/* Header без изменений */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
        <Typography variant='h6' sx={{ flexGrow: 1 }}>
          {`${title}:`}
          {/* {`${title}: ${selectedItems.length}`} */}
        </Typography>
        <IconButton
          size='small'
          onClick={handleAddClick}
          disabled={!availableItems.length}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          size='small'
          disabled={selectedIndex < 1}
          onClick={handleMoveUp}
        >
          <ArrowUpIcon />
        </IconButton>
        <IconButton
          size='small'
          disabled={
            selectedIndex === -1 || selectedIndex === selectedItems.length - 1
          }
          onClick={handleMoveDown}
        >
          <ArrowDownIcon />
        </IconButton>
        <IconButton
          size='small'
          disabled={selectedIndex === -1}
          onClick={handleRemoveItem}
        >
          <DeleteIcon />
        </IconButton>
        {/* {selectedItems.length > 0 && (
          <IconButton size='small' onClick={handleRemoveAll}>
            Очистить все
          </IconButton>
        )} */}
      </Box>

      {/* List с объектами */}
      <List sx={{ maxHeight: 300, overflow: 'auto' }}>
        {selectedItems.length === 0 ? (
          <ListItem>
            <ListItemText primary={emptyMessage || 'Список пуст'} />
          </ListItem>
        ) : (
          selectedItems.map((item, index) => (
            <ListItem
              key={getItemKey(item)} // ✅ Уникальный ключ
              selected={isSelected(index)}
              onClick={() => handleItemClick(index)}
              sx={{
                cursor: 'pointer',
                // '&.Mui-selected': { backgroundColor: '#e3f2fd' },
                // '&.Mui-selected:hover': { backgroundColor: '#bbdefb' },
              }}
            >
              <ListItemIcon>
                <DragIcon fontSize='small' />
              </ListItemIcon>
              <ListItemText
                primary={item.title} // ✅ Показываем title
                // secondary={`(${item.type})`} // Тип для справки
              />
            </ListItem>
          ))
        )}
      </List>

      {/* Menu с доступными */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {availableItems.map((item) => (
          <MenuItem key={getItemKey(item)} onClick={() => handleAddItem(item)}>
            <ListItemText
              primary={item.title}
              // secondary={item.type}
            />
          </MenuItem>
        ))}
        {availableItems.length === 0 && (
          <MenuItem disabled>Все пункты добавлены</MenuItem>
        )}
      </Menu>
    </Box>
  );
};

// const Multiselect = ({ allItems, selectedItems, setSelectedItems, title }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedIndex, setSelectedIndex] = useState(-1);

//   const handleAddClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleAddItem = (item) => {
//     const newSelected = [...selectedItems, item];
//     setSelectedItems(newSelected);
//     setAnchorEl(null);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleItemClick = (index) => {
//     setSelectedIndex(index);
//   };

//   const handleMoveUp = () => {
//     if (selectedIndex > 0) {
//       const newSelected = [...selectedItems];
//       [newSelected[selectedIndex - 1], newSelected[selectedIndex]] = [
//         newSelected[selectedIndex],
//         newSelected[selectedIndex - 1],
//       ];
//       setSelectedItems(newSelected);
//       setSelectedIndex(selectedIndex - 1);
//     }
//   };

//   const handleMoveDown = () => {
//     if (selectedIndex < selectedItems.length - 1 && selectedIndex >= 0) {
//       const newSelected = [...selectedItems];
//       [newSelected[selectedIndex], newSelected[selectedIndex + 1]] = [
//         newSelected[selectedIndex + 1],
//         newSelected[selectedIndex],
//       ];
//       setSelectedItems(newSelected);
//       setSelectedIndex(selectedIndex + 1);
//     }
//   };

//   const handleRemoveItem = () => {
//     if (selectedIndex >= 0) {
//       const newSelected = selectedItems.filter(
//         (_, index) => index !== selectedIndex
//       );
//       setSelectedItems(newSelected);
//       setSelectedIndex(-1);
//     }
//   };

//   const handleRemoveAll = () => {
//     setSelectedItems([]);
//     setSelectedIndex(-1);
//   };

//   const availableItems = allItems.filter(
//     (item) => !selectedItems.includes(item)
//   );

//   const isSelected = (index) => index === selectedIndex;

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         border: '1px solid #e0e0e0',
//         borderRadius: 1,
//         p: 2,
//         mt: 2,
//       }}
//     >
//       {/* Header */}
//       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
//         <Typography variant='h6' sx={{ flexGrow: 1 }}>
//           {`${title || 'Выбор'}:`}
//         </Typography>
//         <IconButton size='small' onClick={handleAddClick}>
//           <AddIcon />
//         </IconButton>
//         <IconButton
//           size='small'
//           disabled={selectedIndex < 1}
//           onClick={handleMoveUp}
//         >
//           <ArrowUpIcon />
//         </IconButton>
//         <IconButton
//           size='small'
//           disabled={
//             selectedIndex === -1 || selectedIndex === selectedItems.length - 1
//           }
//           onClick={handleMoveDown}
//         >
//           <ArrowDownIcon />
//         </IconButton>
//         <IconButton
//           size='small'
//           disabled={selectedIndex === -1}
//           onClick={handleRemoveItem}
//         >
//           <DeleteIcon />
//         </IconButton>
//       </Box>

//       {/* List */}
//       <List sx={{ maxHeight: 300, overflow: 'auto' }}>
//         {selectedItems.length === 0 ? (
//           <ListItem>
//             <ListItemText primary='Список пуст' />
//           </ListItem>
//         ) : (
//           selectedItems.map((item, index) => (
//             <ListItem
//               key={item}
//               selected={isSelected(index)}
//               onClick={() => handleItemClick(index)}
//               sx={{
//                 cursor: 'pointer',
//                 '&.Mui-selected': {
//                   backgroundColor: '#e3f2fd',
//                 },
//                 '&.Mui-selected:hover': {
//                   backgroundColor: '#bbdefb',
//                 },
//               }}
//             >
//               <ListItemIcon>
//                 <DragIcon fontSize='small' />
//               </ListItemIcon>
//               <ListItemText primary={item} />
//             </ListItem>
//           ))
//         )}
//       </List>

//       {/* Add Menu */}
//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//       >
//         {availableItems.map((item) => (
//           <MenuItem key={item} onClick={() => handleAddItem(item)}>
//             {item}
//           </MenuItem>
//         ))}
//         {availableItems.length === 0 && (
//           <MenuItem disabled>Все элементы добавлены</MenuItem>
//         )}
//       </Menu>
//     </Box>
//   );
// };

export default Multiselect;
